var _rect, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";
import { forwardRef } from "react";

var SvgCalendarioIcon = function SvgCalendarioIcon(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    strokeWidth: 25,
    stroke: "#97077d",
    fill: "#fff",
    xmlns: "http://www.w3.org/2000/svg",
    className: "ionicon s-ion-icon",
    viewBox: "0 0 512 512",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Calendar") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    strokeLinejoin: "round",
    x: 48,
    y: 80,
    width: 416,
    height: 384,
    rx: 48,
    className: "ionicon-fill-none ionicon-stroke-width"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    fill: "#97077d",
    strokeWidth: 5,
    cx: 376,
    cy: 232,
    r: 24
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    fill: "#97077d",
    strokeWidth: 5,
    cx: 296,
    cy: 312,
    r: 24
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    fill: "#97077d",
    strokeWidth: 5,
    cx: 376,
    cy: 312,
    r: 24
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    fill: "#97077d",
    strokeWidth: 5,
    cx: 296,
    cy: 232,
    r: 24
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    fill: "#97077d",
    strokeWidth: 5,
    cx: 136,
    cy: 312,
    r: 24
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    fill: "#97077d",
    strokeWidth: 5,
    cx: 216,
    cy: 312,
    r: 24
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    fill: "#97077d",
    strokeWidth: 5,
    cx: 136,
    cy: 392,
    r: 24
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    fill: "#97077d",
    strokeWidth: 5,
    cx: 216,
    cy: 392,
    r: 24
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    fill: "#97077d",
    strokeWidth: 5,
    cx: 296,
    cy: 392,
    r: 24
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    d: "M128 48v32M384 48v32",
    className: "ionicon-fill-none ionicon-stroke-width"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "M464 160H48",
    className: "ionicon-fill-none ionicon-stroke-width"
  })));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgCalendarioIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/calendario_icon.beae1d81aca93934c4105b02d1f19ba1.svg";